import { render } from "./CountryInfo.vue?vue&type=template&id=6295b412&scoped=true"
import script from "./CountryInfo.vue?vue&type=script&lang=js"
export * from "./CountryInfo.vue?vue&type=script&lang=js"

import "./CountryInfo.vue?vue&type=style&index=0&id=6295b412&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6295b412"]])

export default __exports__